// The Chaukas backend (Supabase, Mumbai), as in android/app/build.gradle.kts. The
// key is the project's publishable key, which is public by design: what a person
// may see and change is decided by the database's access rules, not by this key.
// A build for another project can set VITE_SUPABASE_URL and VITE_SUPABASE_KEY.
export const SUPABASE_URL: string =
  import.meta.env.VITE_SUPABASE_URL ?? "https://fkrdbgpdsrbwxorwpotc.supabase.co";
export const SUPABASE_KEY: string =
  import.meta.env.VITE_SUPABASE_KEY ?? "sb_publishable_fvakQmeVz-35G-j87Ap1vA_8vLUWcuq";
